module.exports = __webpack_public_path__ + "static/media/appleMusic.1bcaf4d8.svg";